<template>
  <div class="information-page text-center">
    <TopMenu
      :title="$t('PAGE.' + formatCodeName($route.params.information))"
      back-to="/dashboard"
      dark-background/>
    <div class="container-fluid content">
      <div class="row-item-transparent-with-border mt-3 mb-4 pr-4 pl-4 text-left">
        <h3>{{ selectedPage.title }}</h3>
      </div>
      <div
        v-for="(content, index) in getPageContentsOrdered"
        :key="index">
        <div
          v-if="content.contentType && content.contentType.toLowerCase() === 'text'"
          class="pr-4 pl-4 text-left">
          <p> {{ content.text }}</p>
        </div>
        <div
          v-if="content.contentType && content.contentType.toLowerCase() === 'html'"
          class="pr-4 pl-4 text-left"
          v-html="content.html">
          <p> {{ content.html }}</p>
        </div>
        <div
          v-if="content.contentType && content.contentType.toLowerCase() === 'link'"
          class="pt-2 pb-2 pr-4 pl-4">
          <a
            :href="content.link"
            target="_blank"
            class="btn btn-lg btn-secondary btn-block">{{ content.text }}</a>
        </div>
        <div
          v-if="content.contentType && content.contentType.toLowerCase() === 'phone'"
          class="pt-2 pb-2 pr-4 pl-4">
          <a
            :href="'tel:' + content.phoneNumber"
            class="btn btn-lg btn-primary btn-block"><i class="fas fa-phone mr-2"/>{{ content.text }}</a>
        </div>
        <div
          v-if="content.contentType && content.contentType.toLowerCase() === 'email'"
          class="pt-2 pb-2 pr-4 pl-4">
          <a
            :href="'mailto:' + content.email"
            class="btn btn-lg btn-primary btn-block"><i class="fas fa-envelope mr-2"/>{{ content.text }}</a>
        </div>
      </div>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';

export default {
  name: 'InformationPage',
  components: {
    TopMenu,
    BottomMenu,
  },
  computed: {
    ...mapState('informationPage', ['selectedPage']),
    ...mapGetters('informationPage', [
      'getPageContentsOrdered',
      'formatCodeName',
    ]),
  },
  watch: {},
  created() {
    this.$store.dispatch('informationPage/getPageInformation', {
      name: this.formatCodeName(this.$route.params.code),
      lang: this.$i18n.locale,
    });
  },
  methods: {},
};
</script>

<style scoped lang="scss">
div {
  &.information-page {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
